import React, { useState, useEffect, useMemo } from 'react';
import GridTradeOffer from './GridTradeOffer';
import translations from '../../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const ViewTradeOffer = ({ tradeOffers, userId, liveCsrfToken, fetchTradeOffers,preSelectedTransaction }) => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = key => translations.ViewSaleOffer?.[key]?.[currentLang] || key;
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState('Waiting');
  const params = new URLSearchParams();
  params.set('sellView', 'soldOrOffer');
  const options = [
    'Waiting', 'Accepted', 'Completed', 'Sent', 'Countered', 'Rejected'
  ];
console.log('offer321',tradeOffers)
  const filterTradeOffers = useMemo(() => {
    return (status) => {
      if (status === 'Waiting') {
        return tradeOffers.filter((offer) => offer.Status === status && parseInt(offer.wantedUserId) === parseInt(userId));
      } else if (status === 'Sent') {
        return tradeOffers.filter((offer) => offer.offerUserId === userId);
      } else if (status === 'Countered') {
        return tradeOffers.filter((offer) => offer.IsitACounterOffer === 1);
         } 
       else {
        return tradeOffers.filter((offer) => offer.Status === status);
      }
    };
  }, [tradeOffers, userId]);

  const counts = useMemo(() => {
    return options.reduce((acc, option) => {
      const filtered = filterTradeOffers(option);
      const uniqueTradeIds = new Set(filtered.map((item) => item.tradeId));
      acc[option] = uniqueTradeIds.size;
      return acc;
    }, {});
  }, [filterTradeOffers]);
  

  return (
    <div className="view-sale-offers-global">
  
      <div className="view-sale-offers">
      <div className="menu-container">
      <div className="menu buyer-menu">
            
            <div className="menu-list">
        {options.map(option => (
          <div
            key={option}
            className={`menu-item ${selectedOption === option ? 'active' : ''}`}
            onClick={() => {
              setSelectedOption(option);
            
              const params = new URLSearchParams(location.search);
              params.set('preselected', option);  // Update preselected in the URL
              params.set('sellView', 'soldOrOffer');  // Ensure sellView stays in the URL
              
              const newUrl = `${location.pathname}?${params.toString()}`;
              window.history.replaceState(null, '', newUrl);
            }}
          >
           
            {t(option)}({counts[option]})
              
          </div>
        ))}
      </div>
 </div>
      </div>
      </div> 
       
      <div className="offers-container Extra">
        <GridTradeOffer
          tradeOffers={filterTradeOffers(selectedOption)}
          Status={selectedOption}
          userId={userId}
          liveCsrfToken={liveCsrfToken}
          fetchTradeOffers={fetchTradeOffers}
          preSelectedTransaction={preSelectedTransaction}
        />
     
    </div>
    </div>
  );
};

export default ViewTradeOffer;
